import React, { FC, useState } from 'react';
import { IMessage } from '@sv-support-sdk/chat-shared-types/src/common/messages';
import ActionsItem from '@sv-support-sdk/ui-components/src/components/ControlLayout/Actions/ActionsItem';
import Actions from '@sv-support-sdk/ui-components/src/components/ControlLayout/Actions';

import Notification from './Notification';
import MessagePlaceholder from '../../ui/Content/Message/MessagePlaceholder';
import Headline from '../../ui/Typography/Headline';
import Button from '../../ui/Controls/Button';
import { startStream } from '../../../store/actions/chat';
import { answerCallback } from '../../../store/actions/messages';
import { useAppDispatch } from '../../../store/hooks';
import { $l } from '../../../locales';
import { MESSAGE_ID_NAME } from '../../../constants/messages';
import setQaAttribute from '../../../helpers/setQaAttribute';
import { CHAT_CALLBACK_ALLOW, CHAT_CALLBACK_CANCEL } from '../../../constants/qaAttributes';

const Callback: FC<{ message: IMessage }> = ({ message }) => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  if (message.callback?.type !== 'screen_share') {
    return;
  }

  if (message.callback.answer !== null) {
    const answerMessage = message.callback.answer ? $l('YOU_ALLOWED') : $l('YOU_CANCELED');

    return (
      <Notification
        key={message.id || message.uuid}
        title={$l('THANK_YOU')}
        message={`${answerMessage} ${$l('SHARE_SCREEN')}`}
      />
    );
  }

  const updateCallback = async (answer: number) => {
    if (answer) {
      dispatch(startStream());
    }

    if (!message.callback) {
      return;
    }

    try {
      setLoading(true);
      await dispatch(answerCallback(message.callback.id, message.id, answer));
    } finally {
      setLoading(false);
    }
  };

  return (
    <MessagePlaceholder id={`${MESSAGE_ID_NAME}${message.id}`}>
      <Headline type="secondary" fontSize="16">
        {$l('SCREEN_SHARE_CONFIRM')}
      </Headline>
      <Actions width="full" gap="16">
        <ActionsItem width="full">
          <Button
            text={$l('CANCEL')}
            variant="primary-outlined"
            size="small"
            disabled={loading}
            {...setQaAttribute(CHAT_CALLBACK_CANCEL)}
            onClick={() => updateCallback(0)}
          />
        </ActionsItem>
        <ActionsItem width="full">
          <Button
            text={$l('ALLOW')}
            size="small"
            disabled={loading}
            onClick={() => updateCallback(1)}
            {...setQaAttribute(CHAT_CALLBACK_ALLOW)}
          />
        </ActionsItem>
      </Actions>
    </MessagePlaceholder>
  );
};

export default Callback;
